import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const currencySymbols: Record<string, string> = {
  USD: "$",
  LBP: "LBP ",
  EUR: "€",
};

export function formatCurrency(amount: number, fractionDigits = 2, currency = "USD") {
  const value = Number.isFinite(amount) ? amount : 0;
  const sign = value < 0 ? "-" : "";
  const symbol = currencySymbols[currency.toUpperCase()] ?? `${currency.toUpperCase()} `;
  return `${sign}${symbol}${Math.abs(value).toFixed(fractionDigits)}`;
}
